import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import Tooltip, {
  tooltipClasses,
  type TooltipProps,
} from '@mui/material/Tooltip';

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: theme.typography.body1.fontSize,
    lineHeight: '1.4rem',
    maxWidth: 170,
  },
}));

export const CopyToClipboardWrapper = ({
  children,
  content,
}: {
  children: React.ReactElement<unknown>;
  content: string;
}) => {
  const [copied, setCopied] = useState<boolean>(false);

  useEffect(() => {
    if (copied) {
      const timer = setTimeout(() => setCopied(false), 4000);
      return () => clearTimeout(timer);
    }
  }, [copied]);

  const handleClick = () => {
    navigator.clipboard.writeText(content);
    setCopied(true);
  };

  return (
    <Box component="span" onClick={handleClick}>
      <StyledTooltip
        describeChild
        disableFocusListener
        disableHoverListener
        disableTouchListener
        onClose={() => setCopied(false)}
        open={copied}
        slotProps={{
          popper: {
            disablePortal: true,
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, -10],
                },
              },
            ],
          },
        }}
        title="Copiado para a área de transferência"
      >
        {children}
      </StyledTooltip>
    </Box>
  );
};
